export default __webpack_public_path__ + "static/client_logo_unilever-aad0cd69bf9cef817baa18bd081facdd.svg";